/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AssignSubjectCoordinatorsDTO
 */
export interface AssignSubjectCoordinatorsDTO {
    /**
     *
     * @type {string}
     * @memberof AssignSubjectCoordinatorsDTO
     */
    subjectId?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof AssignSubjectCoordinatorsDTO
     */
    courseCoordinatorIds?: Array<string> | null;
    /**
     *
     * @type {Array<string>}
     * @memberof AssignSubjectCoordinatorsDTO
     */
    labCoordinatorIds?: Array<string> | null;
}

export function AssignSubjectCoordinatorsDTOFromJSON(json: any): AssignSubjectCoordinatorsDTO {
    return AssignSubjectCoordinatorsDTOFromJSONTyped(json, false);
}

export function AssignSubjectCoordinatorsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignSubjectCoordinatorsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'courseCoordinatorIds': !exists(json, 'courseCoordinatorIds') ? undefined : json['courseCoordinatorIds'],
        'labCoordinatorIds': !exists(json, 'labCoordinatorIds') ? undefined : json['labCoordinatorIds'],
    };
}

export function AssignSubjectCoordinatorsDTOToJSON(value?: AssignSubjectCoordinatorsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'subjectId': value.subjectId,
        'courseCoordinatorIds': value.courseCoordinatorIds,
        'labCoordinatorIds': value.labCoordinatorIds,
    };
}

